import { render, staticRenderFns } from "./multiDialog.vue?vue&type=template&id=2ad6edaa&"
import script from "./multiDialog.vue?vue&type=script&lang=js&"
export * from "./multiDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports